import { useMemo } from "react";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

export function useAutoRefreshStyles() {
  return useMemo(
    () => mergeStyleSets({
      input: {
        width: `100px`
      }
    }),
    []
  );
}
